import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from '../../components'
import { Box } from '@mui/material';

const AbonosTabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        base={'/abonos/comercio'}
        panels={[
          {
            name: "Abonos",
            route: '/abonos/comercio/notificaciones',
            onChange: () => navigate('/abonos/comercio/notificaciones'),
            content: <Outlet />
          },
          {
            name: "Historial",
            route: '/abonos/comercio/historial',
            onChange: () => navigate('/abonos/comercio/historial'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default AbonosTabScreen